import { CurrencyApi } from '@api';
import { currencyTypes as actionTypes } from './types';

export const fetchCurrencies = (locale) => (dispatch) => {
  dispatch({
    type: actionTypes.LOADING,
  });

  CurrencyApi.getList({ locale })
    .then((response) => {
      dispatch({
        type: actionTypes.SUCCESS,
        payload: { [locale]: response },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
